import { Step } from './types';

const initialSteps: Array<Step> = [
  'product',
  'upsell',
  'cart',
  'contact',
  'checkout',
  'purchaseFailure',
  'purchaseSuccess',
];

export const initialRouterState = {
  currentStep: 'product' as Step,
  steps: initialSteps,
};
